export const money = value => `$${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const workflowLabel = status => ({
  scheduled: "Scheduled",
  awaiting_review: "Awaiting Review",
  sending: "Sending",
  sent: "Sent",
  partially_paid: "Partially Paid",
  paid: "Paid",
  on_hold: "On Hold",
  void: "Void",
}[status] || String(status || "scheduled").replaceAll("_", " "));

export const workflowClass = status => ({
  awaiting_review: "border-amber-300 bg-amber-100 text-amber-900",
  sending: "border-cyan-300 bg-cyan-100 text-cyan-900",
  sent: "border-emerald-300 bg-emerald-100 text-emerald-900",
  partially_paid: "border-blue-300 bg-blue-100 text-blue-900",
  paid: "border-blue-300 bg-blue-100 text-blue-900",
  on_hold: "border-rose-300 bg-rose-100 text-rose-900",
  void: "border-slate-300 bg-slate-100 text-slate-500",
}[status] || "border-slate-300 bg-slate-100 text-slate-700");

export const triggerLabel = trigger => ({
  project_activated: "Project activated",
  general_production_completed: "Shop production complete",
  lifecycle_completed: "Project completed",
  manual: "Manual",
}[trigger] || String(trigger || "Manual").replaceAll("_", " "));

export const milestoneTestId = milestone => ({
  retainer: "milestone-row-50-retainer",
  pre_delivery: "milestone-row-40-predelivery",
  final: "milestone-row-10-postinstall",
}[milestone.kind] || `milestone-row-${milestone.milestone_id}`);
